<template>
    <div>
        <div class="acctitle flx alc jsb">
            <div class="actleft">
                <el-button type="primary" @click="toAdd">+ 发布活动</el-button>
            </div>
            <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                <div class="acrtips">
                    为了不影响您活动报名、提现和管理，请及时认证
                </div>
                <el-button type="primary" @click="toConfirm">马上认证</el-button>
            </div>
        </div>
        <el-tabs ref="tabRef" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="num1 > 0?`在线中·${num1}` : '在线中'" name="0">
                <List @changeTab="hs" @getNums="getnums" :type="0" v-if="activeName == 0"></List>
            </el-tab-pane>
            <el-tab-pane :label="num2 > 0?`已结束·${num2}` : '已结束'" name="1">
                <List @changeTab="hs" @getNums="getnums" :type="1" v-if="activeName == 1"></List>
            </el-tab-pane>
            <el-tab-pane :label="num3 > 0?`审核中·${num3}` : '审核中'" name="2">
                <List @changeTab="hs" @getNums="getnums" :type="2" v-if="activeName == 2"></List>
            </el-tab-pane>
            <el-tab-pane label="未过审" name="3">
                <List @changeTab="hs" @rfh="refreshs" @getNums="getnums" :type="3" v-if="activeName == 3"></List>
            </el-tab-pane>
            <el-tab-pane :label="num5 > 0?`草稿箱·${num5}` : '草稿箱'" name="4">
                <List @changeTab="hs" @getNums="getnums" :type="4" v-if="activeName == 4"></List>
            </el-tab-pane>
			<el-tab-pane label="已取消" name="5">
			    <List @changeTab="hs" @getNums="getnums" :type="5" v-if="activeName == 5"></List>
			</el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { shoUserInfo } from "@/api/index.js"
import List from './list.vue'
export default {
    name: 'Activity',
    components: { List },
    data() {
        return {
            activeName: '0',
            info: { level: 2 },
            showLogin: false,
            num1: 0,
            num2: 0,
            num3: 0,
            num4: 0,
            num5: 0,
        };
    },
    mounted() {
        this.getUserinfo()
        this.$nextTick(() => {
            window.scrollTo(0, 0)
            this.updateBadgeDot()
        })
    },
    methods: {
        refreshs(){
            this.$emit('rfh')
        },
        hs(e) {
            this.activeName = e + ''
        },
        getnums(e) {
            this.num1 = e[0]
            this.num2 = e[1]
            this.num3 = e[2]
            this.num4 = e[3]
            this.num5 = e[4]
            this.$nextTick(() => {
                this.updateBadgeDot()
            })
        },
        // 核心方法：手动给未过审tab添加/移除红点DOM
        updateBadgeDot() {
            if (!this.$refs.tabRef) return
            // 获取导航栏全部tab按钮
            const tabsNavItems = this.$refs.tabRef.$refs.nav.$el.querySelectorAll('.el-tabs__item')
            // name="3" 是第四个tab，下标索引 3
            const targetTabItem = tabsNavItems[3]
            if (!targetTabItem) return

            // 先清除旧红点
            const oldDot = targetTabItem.querySelector('.custom-tab-badge')
            if(oldDot) oldDot.remove()

            // num4>0 插入红点
            if(this.num4 > 0){
                const dot = document.createElement('span')
                dot.className = 'custom-tab-badge'
                targetTabItem.style.position = 'relative'
                targetTabItem.appendChild(dot)
            }
        },
        toConfirm() {
            this.$router.push('/verify')
        },
        getUserinfo() {
            let that = this
            shoUserInfo().then((res) => {
                if (res.code == 1) {
                    that.info = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        handleClick(tab) {
            // 切换tab后重新维护红点，防止element内部DOM重置把红点删掉
            this.$nextTick(()=>this.updateBadgeDot())
        },
        toAdd() {
            this.$router.push('/AddActivity')
        }
    }
}
</script>

<style scoped>
    .liMiddle { margin-left: 86px; }
    .liEdit { font-size: 16px; color: #007AFF; }
    .liDes { font-size: 14px; color: #999999; text-align: left; }
    .liTop { font-weight: 500; font-size: 20px; color: #222222; line-height: 28px; margin-bottom: 4px; }
    .liName { font-size: 18px; font-weight: 600; margin-bottom: 16px; }
    .liDes { font-size: 14px; color: #555C70; }
    .listItem { box-sizing: border-box; padding: 20px 30px; border-radius: 10px; border: 1px solid #D9D9D9; margin-bottom: 20px; }
    .lists { box-sizing: border-box; padding: 0 30px 0; }
    .acctitle { box-sizing: border-box; padding: 28px 30px 0; }

    /* 自定义红点样式，深度穿透 */
    ::v-deep .custom-tab-badge {
        position: absolute;
        top: 12px;
        right: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #f56c6c;
    }
</style>
